import {useEffect} from 'react';
import CryptoJS from 'crypto-js';
import {useSearchParams} from 'react-router-dom';
import {useNativeAuth} from '../modules/auth/native/NativeAuthProvider';

const EcDeskRedirect = () => {
  const {claims} = useNativeAuth();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const redirectUrl = process.env.REACT_APP_EC_DESK;
    const secretKey = process.env.REACT_APP_ECV1_SECRET;
    const iv = process.env.REACT_APP_ECV1_IV;
    const nextParam = searchParams.get('next');

    if (!redirectUrl || !secretKey || !iv) {
      console.error("Variables d'environnement manquantes");
      return;
    }

    // Identity comes from the JWT claims.
    const username = claims?.preferred_username as string | undefined;
    if (!username) {
      return;
    }

    const payload = {
      username,
      datetime: new Date().toISOString(),
    };

    const encryptedToken = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      CryptoJS.enc.Hex.parse(secretKey),
      {iv: CryptoJS.enc.Hex.parse(iv), mode: CryptoJS.mode.CBC}
    ).toString();

    let redirect = `${redirectUrl}/check-route-auth?t=${encodeURIComponent(encryptedToken)}`;

    if (nextParam) {
      redirect += `&next=${encodeURIComponent(nextParam)}`;
    }
    window.location.replace(redirect);
  }, [claims, searchParams]);

  return null;
};

export default EcDeskRedirect;
